// extracted by mini-css-extract-plugin
export default {"timerAnimation":"Timer_timerAnimation__lJLGO","timeText":"Timer_timeText__i5rbs"};